import { render, staticRenderFns } from "./web-cam.vue?vue&type=template&id=060cffec&scoped=true"
import script from "./web-cam.vue?vue&type=script&lang=js"
export * from "./web-cam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060cffec",
  null
  
)

export default component.exports